(function () {
  'use strict';

  const numericId = (id) => String(id || '').split('/').pop();

  class RccProductInventory extends HTMLElement {
    static get graphqlRequirements() {
      return {
        graphql: [
          `rccInventoryVariants: variants(first: 100) {
            pageInfo { hasNextPage }
            nodes {
              id
              availableForSale
              quantityAvailable
              currentlyNotInStock
            }
          }`,
        ],
      };
    }

    set product(value) {
      this._product = value;
      this.render();
    }

    connectedCallback() {
      this.render();
    }

    render() {
      const product = this._product;
      const settings = window.MundizioCards?.inventory || {};
      const labels = settings.labels || {};
      const template = product?.templateSuffix || product?.template_suffix || '';
      const inventoryVariants = product?.graphql?.rccInventoryVariants?.nodes || [];
      const inventoryById = new Map(inventoryVariants.map((variant) => [numericId(variant?.id), variant]));
      const variants = (product?.variantsAll?.length ? product.variantsAll : inventoryVariants)
        .map((variant) => ({ ...variant, ...inventoryById.get(numericId(variant?.id)) }));
      const selectedId = numericId(product?.variantId);
      const selected = variants.find((variant) => selectedId && numericId(variant?.id) === selectedId)
        || variants.find((variant) => variant.availableForSale === true) || variants[0];

      if (settings.enabled === false || !selected || selected.inventoryTracked === false
          || /coming-soon|countdown/.test(template)
          || (!product?.variantsAll?.length && product?.graphql?.rccInventoryVariants?.pageInfo?.hasNextPage)
          || variants.some((variant) => variant.quantityAvailable == null
            || !Number.isFinite(Number(variant.quantityAvailable)))) {
        this.clear();
        return;
      }

      const total = variants.reduce(
        (sum, variant) => sum + (variant.availableForSale === true
          ? Math.max(0, Number(variant.quantityAvailable)) : 0),
        0,
      );
      const available = variants.some((variant) => variant?.availableForSale === true);
      const backordered = variants.some((variant) => variant?.availableForSale === true
        && variant?.currentlyNotInStock === true);
      let level;
      let text;

      if (total <= 0) {
        if (backordered && !settings.hideBackordered) {
          level = 'backordered';
          text = labels.backordered ?? 'Lieferzeit: 2-4 Werktage';
        }
      } else if (!available) {
        this.clear();
        return;
      } else if (total <= (settings.veryLowThreshold ?? 1)) {
        level = 'very_low';
        text = labels.veryLow ?? '';
      } else if (total <= (settings.lowThreshold ?? 1)) {
        level = 'low';
        text = labels.low ?? 'Begrenzter Vorrat';
      } else {
        level = 'normal';
        text = labels.inStock ?? 'Lieferzeit: 1-2 Werktage';
      }

      if (!level || (level === 'normal' && settings.notice === 'low')) {
        this.clear();
        return;
      }

      this.textContent = text;
      this.hidden = false;
      this.setAttribute('data-inventory-level', level);
      if (level === 'very_low' && !text) this.setAttribute('aria-label', labels.veryLowAccessible ?? 'Sehr geringer Bestand');
      else this.removeAttribute('aria-label');
    }

    clear() {
      this.textContent = '';
      this.hidden = true;
      this.removeAttribute('data-inventory-level');
      this.removeAttribute('aria-label');
    }
  }

  if (!customElements.get('rcc-product-inventory')) {
    customElements.define('rcc-product-inventory', RccProductInventory);
  }
})();
